export function isKiosk(): boolean {
  return window.location.hostname.startsWith('kiosk.');
}
